// @ts-nocheck
import type { ItemDefinition } from '../../../../../shims/appStub';
import type { ItemMetricKey } from '../../types/binding';

export interface DescendantTimestampAggregates {
  maxLastEdited: number | null;
  maxLastMoved: number | null;
  maxLastViewed: number | null;
  minLastEdited: number | null;
  minLastMoved: number | null;
  minLastViewed: number | null;
}

export interface CategoryPropertyCountResult {
  filled: number;
  unfilled: number;
}

/** Recursive descendant counts split by structural container vs leaf. */
export interface DescendantChildCounts {
  total: number;
  containerCount: number;
  leafCount: number;
}

/** Host-provided async metric resolution (DB / filesystem). */
export interface ItemMetricsAdapter {
  countDirectChildren(itemId: number): Promise<number>;
  countContainerChildren(itemId: number): Promise<number>;
  countLeafChildren(itemId: number): Promise<number>;
  getDescendantChildCounts(itemId: number): Promise<DescendantChildCounts>;
  getListDepth(itemId: number): Promise<number>;
  getGraphDepth(itemId: number): Promise<number>;
  countIncomingEdges(itemId: number): Promise<number>;
  hasCanvasThumb(itemId: number): Promise<boolean>;
  getSvgBackgroundBytes(item: ItemDefinition): Promise<number>;
  getCategoryPropertyCounts(
    item: ItemDefinition,
    categoryIds: readonly string[],
  ): Promise<CategoryPropertyCountResult>;
  getDescendantTimestampAggregates(itemId: number): Promise<DescendantTimestampAggregates>;
}

export const SYNC_ITEM_METRIC_KEYS: readonly ItemMetricKey[] = [
  'outEdgeCount',
  'imageCount',
  'documentCount',
  'categoryCount',
  'tagCount',
  'historyEntryCount',
  'hasSvgImage',
  'hasPngImage',
] as const;

export const ASYNC_ITEM_METRIC_KEYS: readonly ItemMetricKey[] = [
  'childCount',
  'descendantCount',
  'containerChildCount',
  'containerDescendantCount',
  'leafChildCount',
  'leafDescendantCount',
  'listDepth',
  'graphDepth',
  'inEdgeCount',
  'filledCategoryPropertyCount',
  'unfilledCategoryPropertyCount',
  'svgBackgroundBytes',
  'hasCanvasThumb',
  'descendantsMaxLastEdited',
  'descendantsMaxLastMoved',
  'descendantsMaxLastViewed',
  'descendantsMinLastEdited',
  'descendantsMinLastMoved',
  'descendantsMinLastViewed',
] as const;
